import i18n from '../i18n';

/**
 * 後端錯誤 → 畫面訊息：有對應錯誤代碼的顯示三語翻譯（errors.<code>），其他用預設訊息
 * 後端錯誤訊息是英文（給開發者看），不要直接顯示給使用者（照 HR utils/apiError.ts）
 */
export const apiErrorMessage = (error: any, fallbackKey = 'common.messages.operationFailed') => {
  const code = error?.response?.data?.code as string | undefined;
  if (code && i18n.exists(`errors.${code}`)) return i18n.t(`errors.${code}`);
  return i18n.t(fallbackKey);
};
